import { motion } from "framer-motion";

/**
 * Masked line-by-line reveal. lines: array of strings or { text, className }.
 */
export const KineticHeading = ({
  lines = [],
  as = "h1",
  className = "",
  delay = 0,
  stagger = 0.14,
  testid,
}) => {
  const Tag = motion[as] || motion.h1;
  return (
    <Tag className={className} data-testid={testid}>
      {lines.map((line, i) => {
        const text = typeof line === "string" ? line : line.text;
        const cls = typeof line === "string" ? "" : line.className || "";
        return (
          <span key={i} className="block overflow-hidden pb-[0.08em]">
            <motion.span
              className={`block will-change-transform ${cls}`}
              initial={{ y: "115%" }}
              animate={{ y: 0 }}
              transition={{
                duration: 0.9,
                ease: [0.16, 1, 0.3, 1],
                delay: delay + i * stagger,
              }}
            >
              {text}
            </motion.span>
          </span>
        );
      })}
    </Tag>
  );
};
